import React, {useState} from 'react';
import { directDeepLink, SOURCE_HOME, SOURCE_WEBVIEW } from '../../util';
import './ToolsInt.css';
import { cosmosTrackService } from '../../../../cosmosTracking/cosmosTrackService';
import {
	create_and_share_poster,
	create_polls, Tips_from_experts, send_notification
} from '../../../../cosmosTracking/cosmosEvents';


function ToolCardInt(props) {
	const { data } = props;
	const handleClick = (tool, index) => {
		if (index === 0) {
			cosmosTrackService(create_and_share_poster);
			directDeepLink(tool?.deeplink, SOURCE_HOME);
		} else if (index === 1) {
			cosmosTrackService(create_polls);
			directDeepLink(tool?.deeplink, SOURCE_HOME);
		} else if (index === 2) {
			cosmosTrackService(Tips_from_experts);
			directDeepLink(tool?.deeplink, SOURCE_HOME,SOURCE_WEBVIEW );
		} else if (index === 3) {
			cosmosTrackService(send_notification);
			directDeepLink(tool?.deeplink, SOURCE_HOME ,SOURCE_WEBVIEW );
		}
	}

	return (
		<>
			{data?.map((tool, index) => (
				<div key={index} className="tool-card-box" onClick={() => {handleClick(tool,index);}}>
					{index === 0 && <img src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/aug-15-picture-frame.png" alt="Create" width={28} height={28} />}
					{index === 1 && <img src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/aug-15-video.png" alt="Tip & Tricks" width={28} height={28} />}
					{index === 2 && <img src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/aug-15-ticket-discount.png" alt="Create" width={28} height={28} />}
					{index === 3 && <img src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/aug-15-notification-bing.png" alt="Notifications" width={28} height={28} />}
					<h4>{tool?.text}</h4>
					<img src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/aug-15-arrow-right.png" alt="arrow" width={16} />
				</div>
			))}
		</>
	);
}

export default ToolCardInt;
